import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { PersonalizationsService } from '../../base/services/personalizations/personalizations.service';
import { Environment } from '../../models/environment';
import { ProfileService } from '../profile/profile.service';

@Injectable({
  providedIn: 'root'
})
export class LoginGuardService implements CanActivate {

  environment: Environment;

  constructor(
    private _profile: ProfileService,
    private _router: Router,
    private _personalization: PersonalizationsService
  ) {
    this.environment = this._personalization.sendEnv;
   }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    if (this._profile.getToken()) {

      this._router.navigate([this.environment.login.home]);

      return false;
    }

    return true;
  }
}
